import React from "react";
import styles from "./SideCard.module.css";
import AssetsPack from "../../../../../util/AssetsPack";
import clsx from "clsx";
import { SideCardType } from "../../../../../util/QuestionStatus";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../store/common/hooks";
import { setStatusClicked } from "../../../../../store/uiState.slice";

interface SideCardProps {
  type: SideCardType;
  number?: number;
  classNameStyle: string;
}

const SideCard: React.FC<SideCardProps> = ({ type, classNameStyle }) => {
  const dispatch = useAppDispatch();
  const statusClicked = useAppSelector((s) => s.ui.statusClicked);

  const getIcon = (type: SideCardType) => {
    switch (type) {
      case SideCardType.Context:
        return AssetsPack.icons.ICON_NEED_APPROVAL.default;
      case SideCardType.NeedApproval:
        return AssetsPack.icons.ICON_PRE_APPROVED.default;
      case SideCardType.Rejected:
        return AssetsPack.icons.ICON_REJECT.default;
      case SideCardType.Brain:
        return AssetsPack.icons.ICON_CORE.default;
      case SideCardType.Images:
        return AssetsPack.icons.ICON_GALLERY.default;
      case SideCardType.Chat:
        return AssetsPack.icons.ICON_NEED_APPROVAL.default;
      default:
        return null;
    }
  };
  const icon = getIcon(type);

  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        styles["timeline-card"],
        classNameStyle,
        statusClicked == type ? styles["active"] : styles["de-active"]
      )}
      onClick={() => {
        dispatch(setStatusClicked(type));
      }}
    >
      {type != SideCardType.Brain && (
        <div className={styles["row01"]}>
          {type == SideCardType.Context ? "Context" : ""}
        </div>
      )}
      <div className={styles["row02"]}>
        <div
          className={clsx(
            styles["icon"],
            type == SideCardType.Rejected && styles["rejected"]
          )}
        >
          {icon && <img src={`${icon}`} />}
        </div>
        <p
          className={clsx(type == SideCardType.Rejected && styles["rejected"])}
        >
          {t(`sidecard.${type}`)}
        </p>
      </div>
    </div>
  );
};

export default SideCard;
